"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAndPrepareLocalizedAsset = exports.prepareLocalizedAsset = void 0;
const flat_1 = require("flat");
const axios_1 = __importDefault(require("axios"));
const deep_merge_1 = require("./deep-merge");
const prepareLocalizedAsset = (fullLocaleId, assets) => {
    if (!fullLocaleId || fullLocaleId === '') {
        throw new Error('fullLocaleId not provided');
    }
    let language = fullLocaleId.split(/[-_]/)[0];
    return { language, messages: { [language]: (0, flat_1.flatten)(assets) } };
};
exports.prepareLocalizedAsset = prepareLocalizedAsset;
const fetchAndPrepareLocalizedAsset = async (bucketBaseUrl, projectName, fullLocaleId, assetName, fallbackAsset) => {
    if (!fullLocaleId || fullLocaleId === '') {
        throw new Error('fullLocaleId not provided');
    }
    if (!projectName || projectName === '') {
        throw new Error('projectName not provided');
    }
    if (!assetName || assetName === '') {
        throw new Error('assetName not provided');
    }
    if (!fallbackAsset) {
        throw new Error('fallbackAsset required, i.e. a neutral source file or a localized asset that can serve as fallback in case of missing segments');
    }
    let config = {
        crossdomain: true,
        headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'max-age=86400,stale-while-revalidation=300',
        },
    };
    const url = `${bucketBaseUrl}application/${projectName}/${fullLocaleId}/${assetName}`;
    let ultimateFallbackAsset = (0, exports.prepareLocalizedAsset)(fullLocaleId, fallbackAsset);
    let response = await axios_1.default.get(url, config);
    let localizedAsset = (0, exports.prepareLocalizedAsset)(fullLocaleId, response.data);
    let assetsWithFallbacks = (0, deep_merge_1.deepMerge)(ultimateFallbackAsset, localizedAsset);
    return assetsWithFallbacks;
};
exports.fetchAndPrepareLocalizedAsset = fetchAndPrepareLocalizedAsset;
